module.exports = __webpack_public_path__ + "static/media/expired.41e0c17a.svg";